import styled from 'styled-components';

export const Placeholder = styled.div`
    display: ${p => p.display ? p.display : 'inline-flex'};
    width: ${p => p.ldrWidth ? p.ldrWidth : ''};
    height: ${p => p.ldrHeight ? p.ldrHeight : ''};
    margin: ${p => p.margin ? p.margin : ''};
    background-color: ${p => p.bgColor ? p.bgColor : '#d1e5ff'};
`;